{/* <link href="http://api.map.baidu.com/library/IndoorMap/1.0/src/indoor.min.css?v=1.0.1 " rel="stylesheet"
      type="text/css">
<script type="text/javascript" src="http://api.map.baidu.com/library/IndoorMap/1.0/src/indoor.min.js?v=1.0.1 "></script> */}

function loadTdt(map,type){
  map.setMapStyle({
    styleJson: [
      {
        "featureType": "road",
        "elementType": "all",
        "stylers": {
          "visibility": "off"
        }
      },
      {
        "featureType": "background",
        "elementType": "all",
        "stylers": {
          "color": "#ffffffff"
        }
      },
      {
        "featureType": "poilabel",
        "elementType": "all",
        "stylers": {
          "visibility": "off"
        }
      },
      {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": {
          "visibility": "off"
        }
      }
    ]
  });
  const urlPath = process.env.DOCK_ENV ? '/5geoserver' : 'http://www.jneep.net/geoserver'
  let map_type={
    blue: urlPath + '/jinanwp/wms?SERVICE=WMS&VERSION=1.1.1&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&tiled=true&STYLES&LAYERS=jinanwp%3AJINAN_BLDT_PC&tilesOrigin=116.211296081543%2C36.0210151672363&WIDTH=200&HEIGHT=200&SRS=EPSG%3A4326&BBOX=',
    gray: urlPath + '/jinanwp/wms?SERVICE=WMS&VERSION=1.1.1&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&tiled=true&STYLES&LAYERS=jinanwp%3AJINAN_BKDT_PC&tilesOrigin=116.211296081543%2C36.0210151672363&WIDTH=200&HEIGHT=200&SRS=EPSG%3A4326&BBOX=',
    white: urlPath + '/jinanwp/wms?SERVICE=WMS&VERSION=1.1.1&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&tiled=true&STYLES&LAYERS=jinanwp%3AJINAN_WTDT_PC&tilesOrigin=116.211296081543%2C36.0210151672363&WIDTH=255&HEIGHT=255&SRS=EPSG%3A4326&BBOX='
  }

  initMap()
  function initMap() {
    if (window.tdt_tileLayer){
      map.removeTileLayer(tdt_tileLayer)
    }else{
      window.tdt_tileLayer=''
    }
    // let indoorManager = new BMapLib.IndoorManager(map);
    // indoorManager.hideBaseMap()
    // setTimeout(() => {
    //   indoorManager.disableIndoor();
    // }, 2000)
    tdt_tileLayer = new BMap.TileLayer({ isTransparentPng: true });
    tdt_tileLayer.getTilesUrl = function (tileCoord, zoom) {
      var x = tileCoord.x;
      var y = tileCoord.y;
      var PointConvert = new BaiduPointConvert(map);
      var lonlat_0 = PointConvert.tileToLngLat(tileCoord);//瓦片左下角坐标；
      var tileCoord2 = new Object();
      tileCoord2.x = x + 1;
      tileCoord2.y = y + 1;
      var lonlat2_0 = PointConvert.tileToLngLat(tileCoord2);//瓦片右上角坐标；
      //var bbox = [lonlat_0.lng, lonlat_0.lat, lonlat2_0.lng, lonlat2_0.lat,];
      let swpoint1 = lnglat_bd09towgs84(lonlat_0.lng, lonlat_0.lat)
      // let swpoint2 = coordtransform.gcj02towgs84(swpoint1[0], swpoint1[1])

      let nepoint1 = lnglat_bd09towgs84(lonlat2_0.lng, lonlat2_0.lat)
      //根据geoserver WMS服务的规则设置URL
      var url = `${map_type[type] || map_type['white']}${swpoint1[0]},${swpoint1[1]},${nepoint1[0]},${nepoint1[1]}`


      return url;

    }
    tdt_tileLayer.zIndex=-10
    map.addTileLayer(tdt_tileLayer); 
  }
    
  function lnglat_bd09towgs84(lng, lat) {
    //fixme: 此处为济南中心,别的城市会有偏差
    var lng_jinan_center = 116.98;
    var lat_jinan_center = 36.67;

    var lng_out, lat_out, tmp;

    [lng_out, tmp] = bd09togcj02(lng, lat_jinan_center);
    [lng_out, tmp] = gcj02towgs84(lng_out, tmp);

    [tmp, lat_out] = bd09togcj02(lng_jinan_center, lat);
    [tmp, lat_out] = gcj02towgs84(tmp, lat_out);

    return [lng_out, lat_out];
  }
    
    
      function BaiduPointConvert(map) {
        this.map = map;
        //瓦片xy计算出经纬度坐标
        //step1: this.tileToPixel(pixel);百度地图瓦片大小为 256*256，根据 瓦片xy * 256计算出瓦片的像素坐标；
        //step2 : this.pixelToWorld(this.tileToPixel(pixel)) ; 将像素坐标转为平面坐标。
        //step3: this.worldToLngLat(this.pixelToWorld(this.tileToPixel(pixel))); 调用API提供的方法将平面坐标转为经纬度坐标；
        //API说明请参考：http://developer.baidu.com/map/reference/index.php?title=Class:%E5%9C%B0%E5%9B%BE%E7%B1%BB%E5%9E%8B%E7%B1%BB/Projection
        this.tileToLngLat = function (pixel) {
          return this.worldToLngLat(this.pixelToWorld(this.tileToPixel(pixel)));
        }
        this.lngLatToTile = function (lngLat) {
          return this.pixelToTile(this.worldToPixel(this.lngLatToWorld(lngLat)));
        }
        this.pixelToLngLat = function (pixel) {
          return this.worldToLngLat(this.pixelToWorld(pixel));
        }
        this.lngLatToPixel = function (lngLat) {
          return this.worldToPixel(this.lngLatToWorld(lngLat));
        }
        this.tileToPixel = function (pixel) {
          return new BMap.Pixel(pixel.x * 256,
            pixel.y * 256);
        }
        this.pixelToWorld = function (pixel) {
          var zoom = this.map.getZoom();
          return new BMap.Pixel(pixel.x / Math.pow(2, zoom - 18),
            pixel.y / Math.pow(2, zoom - 18));
        }
        this.worldToLngLat = function (pixel) {
          var projection = this.map.getMapType().getProjection();
          return projection.pointToLngLat(pixel)
        }
        this.pixelToTile = function (pixel) {
          return new BMap.Pixel(pixel.x / 256,
            pixel.y / 256);
        }
        this.worldToPixel = function (pixel) {
          var zoom = this.map.getZoom();
          return new BMap.Pixel(pixel.x * Math.pow(2, zoom - 18),
            pixel.y * Math.pow(2, zoom - 18));
        }
        this.lngLatToWorld = function (lngLat) {
          var projection = this.map.getMapType().getProjection();
          return projection.lngLatToPoint(lngLat)
        }
      }
  
    
}
var bd09togcj02 = function bd09togcj02(bd_lon, bd_lat) {
  var bd_lon = +bd_lon;
  var bd_lat = +bd_lat;
  var x = bd_lon - 0.0065;
  var y = bd_lat - 0.006;
  var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_PI);
  var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_PI);
  var gg_lng = z * Math.cos(theta);
  var gg_lat = z * Math.sin(theta);
  return [gg_lng, gg_lat]
};
var gcj02towgs84 = function gcj02towgs84(lng, lat) {
  var lat = +lat;
  var lng = +lng;
  if (out_of_china(lng, lat)) {
    return [lng, lat]
  } else {
    var dlat = transformlat(lng - 105.0, lat - 35.0);
    var dlng = transformlng(lng - 105.0, lat - 35.0);
    var radlat = lat / 180.0 * PI;
    var magic = Math.sin(radlat);
    magic = 1 - ee * magic * magic;
    var sqrtmagic = Math.sqrt(magic);
    dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
    dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
    var mglat = lat + dlat;
    var mglng = lng + dlng;
    return [lng * 2 - mglng, lat * 2 - mglat]
  }
};
var wgs84togcj02 = function wgs84togcj02(lng, lat) {
  var lat = +lat;
  var lng = +lng;
  if (out_of_china(lng, lat)) {
    return [lng, lat]
  } else {
    var dlat = transformlat(lng - 105.0, lat - 35.0);
    var dlng = transformlng(lng - 105.0, lat - 35.0);
    var radlat = lat / 180.0 * PI;
    var magic = Math.sin(radlat);
    magic = 1 - ee * magic * magic;
    var sqrtmagic = Math.sqrt(magic);
    dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
    dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
    var mglat = lat + dlat;
    var mglng = lng + dlng;
    return [mglng, mglat]
  }
};
var PI = 3.1415926535897932384626;
var ee = 0.00669342162296594323;
var a = 6378245.0;
var x_PI = 3.14159265358979324 * 3000.0 / 180.0;
var transformlat = function transformlat(lng, lat) {
  var lat = +lat;
  var lng = +lng;
  var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
  ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0;
  ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0;
  return ret
};

var transformlng = function transformlng(lng, lat) {
  var lat = +lat;
  var lng = +lng;
  var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
  ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0;
  ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0;
  return ret
};
var out_of_china = function out_of_china(lng, lat) {
  var lat = +lat;
  var lng = +lng;
  // 纬度3.86~53.55,经度73.66~135.05
  return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55);
};
var gcj02tobd09 = function gcj02tobd09(lng, lat) {
  var lat = +lat;
  var lng = +lng;
  var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
  var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
  var bd_lng = z * Math.cos(theta) + 0.0065;
  var bd_lat = z * Math.sin(theta) + 0.006;
  return [bd_lng, bd_lat]
};
export {loadTdt}


// WEBPACK FOOTER //
// ./src/utils/loadTdt.js